import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    salaryAdditionList: {
      requesting: false,
      items: [],
      pagination: {
		  current_page: 1,
		  per_page: 10,
		  total: 0,
	  },
      error: null,
      success: false,
      filters: {},
    },
    salaryAdditionDetails: {
      requesting: false,
      error: null,
      success: false,
      data: null
    },
  };

export const salaryAdditionSlice = createSlice({
  name: 'salaryAddition',
  initialState,
  reducers: {
    getSalaryAdditionList: (state, action) => {
        state.salaryAdditionList.requesting = true;
        state.salaryAdditionList.error = null;
        state.salaryAdditionList.items = [];
        state.salaryAdditionList.success = false;
        state.salaryAdditionList.filters = action.payload;
    },
    getSalaryAdditionListSuccess: (state, action) => {
		const { data, current_page, per_page, total} = action.payload;
        state.salaryAdditionList.requesting = false;        
        state.salaryAdditionList.items = data;
        state.salaryAdditionList.success = true; 
        state.salaryAdditionList.pagination.current_page = current_page;
        state.salaryAdditionList.pagination.per_page = per_page;
        state.salaryAdditionList.pagination.total = total;
    },
    getSalaryAdditionListFail: (state, action) => {        
        state.salaryAdditionList.requesting = false;
        state.salaryAdditionList.error = action.payload;
    },
    getSalaryAdditionDetails: (state) => {
        state.salaryAdditionDetails.requesting = true;
        state.salaryAdditionDetails.error = null;
        state.salaryAdditionDetails.data = null;
        state.salaryAdditionDetails.success = false; 
    },
    getSalaryAdditionDetailsSuccess: (state, action) => {
        state.salaryAdditionDetails.requesting = false;
        state.salaryAdditionDetails.data = action.payload;
        state.salaryAdditionDetails.success = true; 
    },
    getSalaryAdditionDetailsFail: (state, action) => {        
        state.salaryAdditionDetails.requesting = false;
        state.salaryAdditionDetails.error = action.payload;
    },
    doSalaryAdditionCreate: (state) => {
        state.salaryAdditionDetails.requesting = true;
        state.salaryAdditionDetails.error = null;
        state.salaryAdditionDetails.data = null;
        state.salaryAdditionDetails.success = false; 
    },
    doSalaryAdditionUpdate: (state) => {
        state.salaryAdditionDetails.requesting = true;
        state.salaryAdditionDetails.error = null;
        state.salaryAdditionDetails.data = null;
        state.salaryAdditionDetails.success = false; 
    },
    doSalaryAdditionDelete: (state) => {
        state.salaryAdditionDetails.requesting = true;
        state.salaryAdditionDetails.error = null;
        state.salaryAdditionDetails.data = null;
        state.salaryAdditionDetails.success = false; 
    },
  },
})

export const { 
    getSalaryAdditionList, getSalaryAdditionListSuccess, getSalaryAdditionListFail,
    getSalaryAdditionDetails, getSalaryAdditionDetailsSuccess, getSalaryAdditionDetailsFail,
    doSalaryAdditionCreate, doSalaryAdditionUpdate, doSalaryAdditionDelete
} = salaryAdditionSlice.actions

export default salaryAdditionSlice.reducer